<template>
  <div class="setHeightFullWhite " v-show="wxShow">
    <div style="text-align:center;padding: 10px 0;">
      <img :src="avatar" style="width:100px;border-radius:99px;border:2px solid #EEE" />
      <div class="cardTitle paddingXm">假日伙伴</div>
    </div>

    <van-cell-group>
      <van-field clearable type="number" v-model="mobile" label="手机号" placeholder="请输入手机号" ref="newMobile" />
      <van-field center type="number" label="验证码" placeholder="请输入验证码" v-model="smCode">
        <van-button v-if="noDown" slot="button" @click="sendSmCode" size="mini" type="primary">发送</van-button>
        <van-button v-else slot="button" size="mini" @click="tishi" type="default">
          <van-count-down :time="time" format="ss 秒" ref="countDown" @finish="finish" />
        </van-button>
      </van-field>
    </van-cell-group>

    <div style="padding: 50px 15px">
      <van-button size="large" type="info" @click="reg">登录</van-button>
    </div>

    <!-- <div
      @click="navVip"
      style="color: #FAB13E;text-align: center;font-size: 14px;padding: 10px 0;margin-top: 20%;cursor: pointer;"
    >切换至假日伙伴管理版</div> -->

  </div>
</template>

<script>
export default {
  data () {
    return {
      avatar: this.$mAssetsPath.logo,
      time: 60 * 1000,
      noDown: true,
      showSmCode: false,
      mobile: null,
      smCode: null,
      stamp: '',
      authorizationShow: false, //授期相关
      wxShow: false,
    }
  },
  created () {
    localStorage.removeItem('token')
    this.$store.state.token = null
    this.wxAuthorizationInfo()
    // this.$mUtil.is_weixin()
    // this.$store.commit('SET_LOGOUT');
  },
  beforeRouteEnter (to, from, next) {
    console.log(to)
    console.log(from)
    next()
  },
  mounted () {
    if (this.isWeixin()) {
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady () {
        // 通过下面这个API隐藏右上角按钮
        WeixinJSBridge.call('hideOptionMenu');
      });
    }

  },
  methods: {
    wxAuthorizationInfo () {
      let stamp = this.$route.query.stamp
      let token = this.$route.query.token

      if (token) {
        let reg = this.$route.query.reg
        if (reg == 1) {
          console.log('到这里了')
          this.$store.commit('SET_TOKEN', token)
          this.loadUserSite()
          this.loadInfo()
          this.redirect()
        } else {
          this.$router.replace({
            path: '/reg',
            query: {
              token: token,
            },
          })
        }
        return
      }

      if (!stamp) {
        location.href = this.$mConfig.baseUrl + '/user/wxlogin'
      } else {
        this.stamp = stamp
        this.wxShow = true
      }
    },

    wxLogin () { },
    // navVip() {
    //   window.open('https://jrhbadmin_h5.jiarixiaodui.com/?#/WxLogin')
    // },
    // tishi() {
    //   this.$toast('发送太频繁,稍后再试')
    // },
    // 结束定时
    finish () {
      console.log(this.time)
      this.$refs.countDown.reset()
      this.noDown = true
    },
    sendSmCode () {
      if (!this.mobile) {
        this.$toast('手机号错误')
        return
      }
      this.noDown = false
      try {
        this.$axios
          .get('user/sms', { params: { mobile: this.mobile } })
          .then((response) => {
            let data = response.data
            if (data.code == 200) {
              this.$toast(data.msg)
            } else {
              this.$toast(data.msg)
            }
          })
      } catch (e) {
        if (this.$Util.debug) {
          console.log(e)
        }
      }
    },
    reg () {
      const that = this
      if (!that.mobile) {
        that.$toast.fail('手机号填写错误')
        return
      } else if (!that.smCode) {
        that.$toast.fail('验证码填写错误')
        return
      } else {
        try {
          let query = {
            mobile: that.mobile,
            code: that.smCode,
            stamp: that.stamp,
          }
          that.$axios.post('user/login', query).then((response) => {
            let data = response.data
            if (data.code == 200) {
              if (data.data.reg == 1) {
                this.$store.commit('SET_TOKEN', data.data.token)
                this.loadUserSite()
                this.loadInfo()
                this.redirect()
              } else {
                that.$router.replace({
                  path: '/reg',
                  query: {
                    mobile: that.mobile,
                    token: data.data.token,
                  },
                })
              }
            } else {
              that.$toast(data.msg)
            }
          })
        } catch (e) {
          if (this.$Util.debug) {
            console.log(e)
          }
        }
      }
    },
    loadUserSite () {
      const that = this
      try {
        this.$axios.get('user/info').then((res) => {
          if (res.data.code == 200) {
            this.$store.commit('ChangeSite', res.data.data.site)
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    loadInfo () {
      try {
        this.$axios.get('user/info').then((res) => {
          if (res.data.code == 200) {
            this.$store.commit('SetInfo', JSON.stringify(res.data.data))
          }
        })
      } catch (e) {
        if (this.$mConfig.debug) {
          console.log(e)
        }
      }
    },
    redirect () {
      let redirect = decodeURIComponent(localStorage.redirectUrl || '/')
      localStorage.removeItem('redirectUrl')
      if (!redirect) {
        redirect = '/center'
      } else if (redirect.indexOf('/WxLogin') == 0) {
        redirect = '/'
      }
      this.$router.replace({
        path: redirect,
      })
    },
  },
}
</script>
